// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { NavLink } from 'react-router-dom'
import { Compass, Briefcase, File, User, Users } from 'react-feather'

// CSS
import './styles.scss'

// Component/Container
import LoadingBox from '../../components/LoadingBox'
import LoadingIcon from '../../components/LoadingIcon'

// Actions
import { fetchCases, changeSwapCaseSearch, defaultCase, fetchSearch, setError } from './actions'
import { changeHeaderVisible } from '../Header/actions'
import { profile } from '../ProfilePage/actions'

class SwapCase extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 0,
      isFetching: false,
    }

    this.changePage = this.changePage.bind(this)
    this.fetchCases = this.fetchCases.bind(this)
    this.searchCase = this.searchCase.bind(this)
  }
  UNSAFE_componentWillMount() {
    const { fetchCases, user } = this.props
    fetchCases(0)
  }

  componentDidMount() {
    const swipeBar = document.querySelector('.swap-case__bar')
    swipeBar.addEventListener('scroll', () => this.infinityLoaderVisibility(this.state.page, this.changePage, this.fetchCases))
  }

  componentWillUnmount() {
    const swipeBar = document.querySelector('.swap-case__bar')
    swipeBar.removeEventListener('scroll', this.infinityLoaderVisibility)
  }

  changePage(page) {
    if (!this.state.isFetching) {
      this.setState({ ...this.state, page })
    }
  }

  fetchCases() {
    const { fetchCases: fetch } = this.props
    this.setState({ ...this.state, isFetching: true }, () => {
      fetch(this.state.page, null,
        () => this.setState({ isFetching: false }))
    })
  }

  infinityLoaderVisibility(page, changePage, fetchCases) {
    const infinityLoader = document.querySelector('.infinity-loader')
    if (infinityLoader && infinityLoader.getBoundingClientRect().top < window.innerHeight) {
      const currentPage = page + 1
      changePage(currentPage)
      fetchCases(currentPage * 15)
    }
  }

  searchCase(evt) {
    const { value: search } = evt.target
    const { changeSwapCaseSearch, defaultCase, fetchSearch, fetchCases, setError } = this.props
    changeSwapCaseSearch(search)
    setError(false)
    if (search.length > 0) {
      defaultCase()
      fetchSearch(search)
    } else {
      defaultCase()
      fetchCases(0)
    }
  }

  render() {
    const { visible, cases, search, changeHeaderVisible, error } = this.props
    const { isFetching } = this.state

    return (
      <div>
        <div className='swap-case'>
          <Compass size="20" onClick={() => changeHeaderVisible('swap-case')} className='swap-case__icon' />
          <div className={visible.status && visible.type === 'swap-case' ? 'swap-case__bar swap-case__bar--visible' : 'swap-case__bar'}>
            <div className='swap-case__bar-search'>
              <input placeholder='Busca por caso' value={search} onChange={this.searchCase}></input>
            </div>
            {cases.map((item, index) => {
              return (
                <NavLink key={index} to={`/meus-casos/${item.id}`} onClick={() => changeHeaderVisible('swap-case')}>
                  <section className='swap-case__card'>
                    <header>
                      <div className={`swap-case__card__dot swap-case__card__dot--${item.status}`} />
                      {item.id}
                    </header>
                    <main>
                      <File size={12} /><span>{item.lawsuitNumber || item.lawsuit?.number}</span>
                      <User size={12} /><span>{item.client.fullName || item.client?.name}</span>
                      <Briefcase size={12} /><span>{item.lawyer.fullName || item.lawyer?.name}</span>
                      <Users size={12} /><span>{item.company?.name}</span>
                    </main>
                  </section>
                </NavLink>
              )
            })}
            {cases.length === 0 && error && !isFetching && <div className="swap-case__error">Nada encontrado</div>}
            {cases.length === 0 && !error && <LoadingBox />}
            {(cases.length > 0) && !isFetching && !search && <div className="infinity-loader" style={{ width: "100%", minHeight: 1 }}></div>}
            {(cases.length > 0) && isFetching && !search && <div className="swap-case__infinity-loader"><LoadingIcon type="grey" size={13} spaceBetweenDots={4} /></div>}
          </div>
        </div>
      </div>
    )
  }
}

SwapCase = connect(state => {
  return {
    user: state.auth.user,
    visible: state.header.visible,
    cases: state.swapCase.case,
    search: state.swapCase.search,
    error: state.swapCase.error,
  }
}, { fetchCases, changeSwapCaseSearch, changeHeaderVisible, profile, defaultCase, fetchSearch, setError })(SwapCase)

export default SwapCase
